import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { db, doc, getDoc } from "../../firebase/Firebase"; // Ensure proper imports
import { useAuthState } from "react-firebase-hooks/auth";
import "./withdrawalCom.css";

const WithdrawalCom = () => {
  const navigate = useNavigate();
  const [user, loading, error] = useAuthState(getAuth());
  const [userData, setUserData] = useState(null); // To store user data including balance
  const [message, setMessage] = useState(""); // For errors or notifications

  // Fetch the user's balance and other data from Firestore
  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        try {
          const userRef = doc(db, "users", user.uid); // Firestore reference to the user's document
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            setUserData(userSnap.data());
          } else {
            setMessage("User data not found. Please contact support.");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          setMessage("Failed to load user data. Please try again later.");
        }
      }
    };

    fetchUserData();
  }, [user]);

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/Deposit");
  };

  // If data is still loading, show a spinner or placeholder
  if (loading) {
    return (
      <div className="withdrawalPage">
        <p>Loading your account details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="withdrawalPage">
        <p>Error: {error.message}</p>
      </div>
    );
  }

  return (
    <>
      <div className="withdrawalPage">
        {message && <p className="message">{message}</p>}{" "}
        {/* Display the message */}
        <div className="withdrawalList">
          <div className="account-balance">
            <span className="boldie">
              ${userData?.balance?.toFixed(2) || "0.00"}
            </span>
            <span>Account Balance</span>
          </div>
          <div className="pending-withdrawal">
            <span className="boldie">$0.0</span>
            <span>Pending Withdrawal</span>
          </div>
          <div className="make-a-profit">
            Withdrawable Account Balance
            <span className="boldie">
              You can make a profit by simply investing
            </span>
            <form onSubmit={handleSubmit}>
              <button type="submit">Invest</button>
            </form>
          </div>
          <div className="processing">
            <div className="responsive-table">
              <table>
                <thead>
                  <tr>
                    <th>Processing</th>
                    <th>Available</th>
                    <th>Pending</th>
                    <th>Account</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Bitcoin</td>
                    <td>${userData?.bitcoinBalance?.toFixed(2) || "0.00"}</td>
                    <td>$0.00</td>
                    <td>not set Loading...</td>
                  </tr>
                  <tr>
                    <td>USDT (TRC 20)</td>
                    <td>${userData?.usdtBalance?.toFixed(2) || "0.00"}</td>
                    <td>$0.00</td>
                    <td>not set Loading...</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WithdrawalCom;
